import { ContainerModule } from 'inversify';
import Tracker from '@framework/analytics-tracker/Tracker';
import EvercallTracker from '@/evercall/application/AnalyticsTracker/EvercallTracker';

export const analyticsModule: ContainerModule = new ContainerModule(({ bind }) => {
  bind(EvercallTracker).toSelf().inSingletonScope();
  bind(Tracker).toDynamicValue(({ get }) => get(EvercallTracker)).inSingletonScope();
});
